<template>
  <el-dialog
    title="未上传成功信息"
    :visible="isUploadFailShow"
    width="400px"
    center
    :close-on-click-modal="false"
    @close="$emit('update:isUploadFailShow', false)"
  >
    <div class="title"><i class="iconfont icon-tip"></i>以下学生学号信息已存在，请勿重复添加</div>
    <el-table
      :data="studentList"
      border
      style="width: 100%"
      tooltip-effect="dark"
      height="250"
    >
      <el-table-column
        prop="studentName"
        :show-overflow-tooltip="true"
        label="姓名"
      >
      </el-table-column>
      <el-table-column
        prop="studentNumber"
        :show-overflow-tooltip="true"
        label="学号"
      >
      </el-table-column>
    </el-table>
    <div slot="footer" class="dialog-footer">
      <el-button
        type="primary"
        @click="$emit('update:isUploadFailShow', false)"
      >
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "",
  props: {
    isUploadFailShow: {
      type: Boolean,
      default: false,
    },
    studentList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@import "./student-upload-fail-list.scss";
</style>